module.exports = __webpack_public_path__ + "static/engineeringStory1-7deb1f42712d4959235cfd252ae71dcd.jpg";